/**
 * A Notification component
 */

import React, { ReactElement } from "react";
import { observer } from "mobx-react";
import IconButton from "../../pieces/IconButton/IconButton";
import { AnimationDuration } from "../../../styles/Animations";
import { Transition } from "react-transition-group";
import { TransitionStatus } from "react-transition-group/Transition";
import forceReflow from "../../../utils/forceReflow";
import { Tick, Delete, Warning, Close, Information } from "../../icons";
import { ButtonSize } from "../../pieces/Button/Button";

interface INotificationProps {
  children: React.ReactNode;
  type: NotificationType;
  onClose: () => void;
  isShowing: boolean;
}

export enum NotificationType {
  Success = "success",
  Error = "error",
  Delete = "delete",
  Info = "info",
}

@observer
export default class Notification extends React.Component<INotificationProps> {
  public static defaultProps = {
    type: NotificationType.Info,
  };

  public render(): ReactElement {
    return (
      <Transition
        timeout={AnimationDuration.Long}
        in={this.props.isShowing}
        onEnter={forceReflow}
        unmountOnExit
        mountOnEnter
      >
        {(status: TransitionStatus): ReactElement => (
          <div className={`notification notification--${status}`} aria-live="polite">
            <div className={`notification__icon notification__icon--${this.props.type} center`}>{this.renderIcon}</div>
            <div className="notification__body">{this.props.children}</div>
            <div className="notification__close">
              <IconButton
                icon={<Close />}
                aria-label="Close notification"
                onClick={this.props.onClose}
                size={ButtonSize.Small}
              />
            </div>
          </div>
        )}
      </Transition>
    );
  }

  private get renderIcon(): ReactElement {
    if (this.props.type === NotificationType.Success) {
      return <Tick />;
    } else if (this.props.type === NotificationType.Delete) {
      return <Delete />;
    } else if (this.props.type === NotificationType.Error) {
      return <Warning />;
    } else {
      return <Information />;
    }
  }
}
